import "./index.less"
import { ReactComponent as AddSvg } from '@/global/icons/side-tool/add.svg';
import { ReactComponent as SelectSvg } from '@/global/icons/side-tool/select.svg';
import { ReactComponent as DeleteSvg } from '@/global/icons/side-tool/delete.svg';
import { ReactComponent as DownloadSvg } from '@/global/icons/side-tool/download.svg';
import { ReactComponent as UnSelectSvg } from '@/global/icons/side-tool/un-select.svg';
import { ReactComponent as EditSvg } from '@/global/icons/side-tool/edit.svg';
import { ReactComponent as UploadSvg } from '@/global/icons/side-tool/upload.svg';
import { Select } from "antd";
import { useContext, useEffect, useState } from "react";
import { SideStatus } from "@/global/store/side-store";
import { SideContext } from "@/App";

interface Iprop {
    onSelectClick?: () => void
    onUnSelectClick?: () => void
    onAddClick?: () => void
    onEditClick?: () => void
    onUploadClick?: () => void
    onDownloadClick?: () => void
    onDeleteClick?: () => void
}

export default function SideTool(props: Iprop) {
    const sideContext = useContext<SideStatus>(SideContext);
    const [selectedPanelValue, setSelectedPanelValue] = useState<string>(); // 下拉选择框选中的值

    useEffect(() => {
        if (["monitor-object", "monitor-parameter", "device-list", "project-device-lib"].includes(sideContext.selectedPanel)) {
            setSelectedPanelValue(sideContext.selectedPanel);
        } else {
            setSelectedPanelValue(null);
        }
    }, [sideContext.selectedPanel])

    // 切换查看侧边数据
    const onChangeSideData = (name: string) => {
        sideContext.setSelectedPanelValue(name)
    }

    return (
        <div className="side-tool">
            <Select onChange={onChangeSideData} value={selectedPanelValue} className="side-select">
                <Select.Option value="monitor-object">监测对象</Select.Option>
                <Select.Option value="monitor-parameter">监测参数</Select.Option>
                <Select.Option value="device-list">设备表</Select.Option>
                <Select.Option value="project-device-lib">项目设备库</Select.Option>
            </Select>

            {props?.onSelectClick && <div className="tool-item" onClick={() => {
                if (props?.onSelectClick) {
                    props.onSelectClick()
                }
            }} >
                <SelectSvg className="item-icon" />
            </div>}
            {props?.onUnSelectClick && <div className="tool-item" onClick={() => {
                if (props?.onUnSelectClick) {
                    props.onUnSelectClick()
                }
            }} >
                <UnSelectSvg className="item-icon" />
            </div>}
            {props?.onAddClick && <div className="tool-item" onClick={() => {
                if (props?.onAddClick) {
                    props.onAddClick()
                }
            }} >
                <AddSvg className="item-icon" />
            </div>}
            {props?.onEditClick && <div className="tool-item" onClick={() => {
                if (props?.onEditClick) {
                    props.onEditClick()
                }
            }} >
                <EditSvg className="item-icon" />
            </div>}
            {props?.onUploadClick && <div className="tool-item" onClick={() => {
                if (props?.onUploadClick) {
                    props.onUploadClick()
                }
            }} >
                <UploadSvg className="item-icon" />
            </div>}
            {props?.onDownloadClick && <div className="tool-item" onClick={() => {
                if (props?.onDownloadClick) {
                    props.onDownloadClick()
                }
            }} >
                <DownloadSvg className="item-icon" />
            </div>}
            {props?.onDeleteClick && <div className="tool-item" onClick={() => {
                if (props?.onDeleteClick) {
                    props.onDeleteClick()
                }
            }} >
                <DeleteSvg className="item-icon" />
            </div>}
        </div>
    )
}